import { RootState } from '../types';

export const getLanguage = (state: RootState) => state.languageState;
export const getMetadata = (state: RootState) => state.matchMediaState;
export const getLoginUser = (state: RootState) => state.loginUserState;
export const getNav = (state: RootState) => state.navState;
